export default "__VITE_ASSET__u0z56Ok9__"